<template>
  <MetricsSummaryWithLoader
    :loading="loading"
    :number-of-summary-skeletons="2"
    :summaries="summaries"
    :project-name="projectName"
    :date-range="dateRange"
  />
</template>

<script setup>
import MetricsSummaryWithLoader from '@/components/insights/Metrics/MetricsSummaryWithLoader.vue';
import { computed } from 'vue';
import { isEmpty } from 'lodash-es';
import { formatTooltipValue } from '@/helpers/formatters';
import { useColors } from '@/composables/colors';

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  tooltips: {
    type: Object,
    default: () => ({}),
  },
  projectName: {
    type: String,
    default: '',
  },
  dateRange: {
    type: Object,
    default: () => ({}),
  },
});

const { brandPrimary } = useColors();

const summaries = computed(() => {
  if (isEmpty(props.data)) return [];

  const {
    net = {}, dropped_out: droppedOut = {},
  } = props.data || {};

  const totalDroppedOut = (droppedOut?.review || 0)
    + (droppedOut?.screen || 0)
    + (droppedOut?.assessment || 0)
    + (droppedOut?.offer || 0)
    + (droppedOut?.hired || 0);

  const dropoffOverall = typeof net?.review === 'number' && net.review > 0
    ? formatTooltipValue((totalDroppedOut / net.review) * 100, 'percent')
    : '-';

  const baseSummaries = [
    {
      id: 'drop-off-average',
      tooltipKey: 'dropoff-overall-net-dropoff-rate',
      label: 'Overall Net Drop-off Rate',
      color: brandPrimary.value,
      value: dropoffOverall,
    },
    {
      id: 'drop-off-average-benchmark',
      tooltipKey: 'dropoff-overall-net-drop-off-rate-benchmark',
      label: 'Overall Net Drop-off Rate Benchmark',
      color: brandPrimary.value,
      value: '4.6%',
    },
  ];

  return baseSummaries.map((summary) => {
    const { body_r: html, mode } = props.tooltips?.[summary.tooltipKey] || {};
    return {
      ...summary,
      tooltip: { html, mode, key: summary.tooltipKey },
    };
  });
});
</script>

<style lang="less" scoped>
:deep(.summary-section) {
  &:first-of-type .summary-label {
    max-width: 115px !important;
  }

  &:last-of-type .summary-label {
    max-width: 145px !important;
  }
}
</style>
